import { render } from "./DepartmentsPage.vue?vue&type=template&id=00a56fc2"
import script from "./DepartmentsPage.vue?vue&type=script&lang=js"
export * from "./DepartmentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__